<template>
    <section>
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
  
      <!--列表-->
      <el-table :data="lists" v-loading="listLoading" style="width: 100%" @select="dialogCheck"
        @row-click="selectCurrentRow" ref="table" class="custom-tbl">
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="Id" label="ID" width="200" sortable></el-table-column>
        <el-table-column prop="Name" label="名称" width="180" sortable></el-table-column>
        <el-table-column prop="Enabled" label="状态" width="" sortable>
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.Enabled ? 'success' : 'danger'"
              disable-transitions
              >{{ scope.row.Enabled ? "正常" : "禁用" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="220" sortable>
        </el-table-column> 
        <el-table-column prop="Token" label="Token" width="180" sortable></el-table-column>
        <el-table-column prop="Remark1" label="备注1" width="180" sortable></el-table-column>
        <el-table-column prop="Remark2" label="备注2" width="180" sortable></el-table-column>
        <el-table-column prop="Remark3" label="备注3" width="180" sortable></el-table-column>
      </el-table>
  
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>
   
  
      <Add  v-if="addFormVisible" :closetc="closetc" ></Add>
  
      <Edit v-if="editFormVisible" :editForm="editForm" :closetc="closetc" ></Edit>
    </section>
  </template>
    
  <script>
  import util from "../../../util/date";
  
  import { getMachinesConfigListPage,removeMachinesConfig} from "../../api/api";
  import { getButtonList } from "../../promissionRouter";
  import Toolbar from "../../components/Toolbar"; 
  import Add from "../MachineConfig/Add.vue";
  import Edit from "../MachineConfig/Edit.vue";
  export default {
    components: {  Toolbar,Add,Edit },
    data() {
      return {  
        ApplyMainPosition:"",   
        buttonList: [],
        currentRow: null,
        filters: {
        },
        lists: [],
        statusList: [
          { LinkUrl: "激活", value: true },
          { LinkUrl: "禁用", value: false },
        ],
        total: 0,
        page: 1,
        pagesize: 20,
        listLoading: false,
        sels: [], //列表选中列 
        detailFormVisible: false,
        //界面数据
        detailData: {
  
        },
        addFormVisible:false,
        addForm:{},
        editFormVisible:false,
        editForm:{}
      };
    },
    methods: { 
        //关闭弹窗 
        closetc(type) {  
        console.log(type)
        this.addFormVisible = false; 
        this.editFormVisible = false; 
        this.$forceUpdate();
        if(type == 1){
          this.getList();
        } 
      },
      //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
  
        return;
      } 
      
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      if( this.editForm.TenantType == "Id"){
        this.editForm.TenantType = "1";
      }
      console.log(this.editForm); 
    },
    //显示新增界面
    handleAdd() {
        console.log("添加。。。。")
      this.addFormVisible = true;
      this.addForm = { 
      };
      this.$forceUpdate();
    },
    
      dialogCheck(selection, row) {
        this.currentRow = null;
        this.$refs.table.clearSelection();
        if (selection.length === 0) {
          return;
        }
        if (row) {
          this.selectCurrentRow(row);
        }
      },
      selectCurrentRow(val) {
        if (val) {
          this.currentRow = val;
          this.$refs.table.clearSelection();
          this.$refs.table.toggleRowSelection(val, true);
        }
      },
      callFunction(item) {
        this.filters = {
          name: item.search,
        };
        this[item.Func].apply(this, item);
      },
      formatCreateTime: function (row, column) {
        return !row.CreateTime || row.CreateTime == ""
          ? ""
          : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd hh:mm:ss");
      },
      handleCurrentChange(val) {
        this.page = val;
        this.getList();
      },
      //获取用户列表
      getList() {
        let para = {
          page: this.page,
          key: this.filters.name,
        };
        this.listLoading = true;
  
        //NProgress.start();
        getMachinesConfigListPage(para).then((res) => {
            console.log(res)
            if(res.data.response != null){
              var result = res.data.response;
              this.total = result.dataCount;
              this.pagesize = result.PageSize;
              this.lists = result.data;
            }
       
            this.listLoading = false;
  
          //NProgress.done();
        });
      },
  
     //删除
     handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });
  
        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removeMachinesConfig(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
  
            this.getList();
          });
        })
        .catch(() => {});
    },
  
    },
    mounted() {
      this.getList();
      
      let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
      this.buttonList = getButtonList(this.$route.path, routers);
    },
  };
  </script>
  
  <style>
  .el-button+.el-button,
  .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0 !important; 
  }
  
  /* .el-button--warning.is-plain { 
      margin-left: 0 !important;
  } */
  </style>
  <style scoped>
  .custom-tbl /deep/ .has-gutter .el-checkbox {
    display: none;
  }
  </style>
    
  